import React from 'react'

function Pages() {
  return (
    <div className="store-pages">Pages</div>
  )
}

export default Pages